import React from 'react'
import { Glyphicon, DropdownButton, MenuItem } from 'react-bootstrap'

type Props = {
  name: String,
  publicKeys: [String],
  door: { display_name: String, controller_index: String, height: String, width: String, depth: String },
  onChange: Function,
}

const defaultProps = {
  door: {
    display_name: 'Fack',
    controller_index: '-1',
    height: '100',
    width: '100',
    depth: '100',
  },
}

const ClusterDoorForm = ({ door, publicKeys, onChange }: Props) => (
  <div style={{ marginTop: 10 }} className="flex">
    <input style={{ width: '20%' }} placeholder="Fack" className="change-input form-control" type="text" name="display_name" value={door.display_name} onChange={onChange} />

    <div className="flex" style={{ width: '30%' }}>
      <DropdownButton className="delivery-filter-container" title={publicKeys[Number(door.controller_index) + 1] || 'Styrenhet'} id="bg-nested-dropdown">
        {publicKeys.map((key, i) => (
          <MenuItem key={key} onSelect={() => onChange({ target: { name: 'controller_index', value: `${i - 1}` } })} className="dropdown-menu-item">
            <Glyphicon glyph={`glyphicon glyphicon-${door.controller_index === `${i - 1}` ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
            {key}
          </MenuItem>
        ))}
      </DropdownButton>
    </div>

    <div style={{ width: '40%', display: 'flex' }}>
      <h4 style={{ marginRight: 10 }}>Dimensioner (cm):</h4>
      <div className="flex">
        {['height', 'width', 'depth'].map((d) => (
          <input style={{ flex: 1 }} className="change-input form-control" key={d} type="text" name={d} value={door[d]} onChange={onChange} />
        ))}
      </div>
    </div>
  </div>
)

ClusterDoorForm.defaultProps = defaultProps

export default ClusterDoorForm
